import ducks from '../ducks'
import thunk from 'redux-thunk'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import { createStore, compose, applyMiddleware } from 'redux'

const persistedReducer = persistReducer({ key: 'root', storage, whitelist: ['auth'] }, ducks)
const Store = createStore(persistedReducer, compose(applyMiddleware(thunk)))

export default Store



// WEBPACK FOOTER //
// ./src/store/index.js